/**
 * Audit Hub constants aligned to the Audit Hub OpenAPI.
 *
 * Lifecycle status query enum: active | completed | cancelled.
 * POST /audits takes integer complianceAddonIds from GET /catalog/frameworks.
 * Control review statuses are for a later control panel.
 */

export const AUDIT_STATUSES = {
  ACTIVE: "active",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
};

export const AUDIT_STATUS_LABEL = {
  active: "Active",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const APPROACHING_COMPLETION_DAYS = 14;

export const REVIEW_STATUSES = [
  { value: "NOT_STARTED", label: "Not Started", color: "#6b7280" },
  { value: "PENDING_ARTIFACTS", label: "Pending Artifacts", color: "#ca8a04" },
  { value: "READY_FOR_REVIEW", label: "Ready for Review", color: "#2563eb" },
  { value: "UNDER_REVIEW", label: "Under Review", color: "#4338ca" },
  { value: "NEEDS_MORE_INFO", label: "Needs More Info", color: "#d97706" },
  { value: "PASSED", label: "Passed", color: "#16a34a" },
  { value: "FAILED", label: "Failed", color: "#dc2626" },
  { value: "NOT_APPLICABLE", label: "Not Applicable", color: "#9ca3af" },
];

export const CREATE_DRAFT_STORAGE_KEY = "cloudcatcher:audit-hub-create-draft";

/** CreateAuditRequest.accountNumber */
export const AWS_ACCOUNT_NUMBER = /^\d{12}$/;

/** Default true until the Audit Hub API is deployed. Set REACT_APP_AUDIT_HUB_MOCK=false to use live HTTP. */
export const AUDIT_HUB_USE_MOCK =
  String(process.env.REACT_APP_AUDIT_HUB_MOCK ?? "true").toLowerCase() !== "false";
